<!-- Events -->
<!-- itemCreated -->

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  class="text-left line-item"
                  style="width: 100px"
                >
                  Item
                </th>
                <th class="text-left line-item">
                  Description
                </th>
                <th class="text-left line-item">
                  Price
                </th>
                <th class="text-left line-item">
                  Qty
                </th>
                <th class="text-left line-item">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(detail, i) in item.details"
                :key="'detail' + detail.invoice + '-' + i"
              >
                <td class="tddetail"><span class="line-item">{{ detail.item }}</span></td>
                <td class="tddetail"><span class="line-item">{{ detail.descriptio }}</span></td>
                <td class="tddetail"><span class="line-item">${{ detail.price.toFixed(2) }}</span></td>
                <td class="tddetail"><span class="line-item">{{ detail.qty }}</span></td>
                <td class="tddetail"><span class="line-item">${{ (detail.qty * detail.price).toFixed(2) }}</span></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { mapActions } from 'vuex'
  import basicMixin from '../../mixins/basic'

  export default {
    name: 'PowInvoiceDetails',

    mixins: [basicMixin],
    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          invoice: undefined,
          due_date: undefined,
          total: undefined,
          paid: undefined,
          balance: undefined,
          is_paid: undefined,
          details: undefined,
        }),
      },
    },
    data: function () {
      return {
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
      }
    },

    computed: {
      // balance: function () {
      //   if (this.currentObject && this.currentObject.total) {
      //     return (this.currentObject.total - this.currentObject.paid).toFixed(2)
      //   }
      //   return 'NaN'
      // },
    },
    async created () {
      this.init()
    },
    async mounted () {
      this.init()
    },
    methods: {
      ...mapActions(['getCloudTowerConfigMembers']),
      init () {
        console.log('Initializing component setting values!', this.item)
        this.formMode = 'read'
        // console.log(val)
        this.currentObject = { ...this.item }
        this.snapshotObject = { ...this.item }
      },
      resetForm () {
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
    },

  }
</script>

<style>
  .tddetail {
    height: 10px;
  }
  .line-item {
    font-size: 18px;
    font-family: Roboto, sans-serif;
  }

</style>
